import React from "react";
import Lucide from "src/base-components/Lucide";
import { Dialog } from "src/base-components/Headless";

interface ActionItem {
  label: string;
  description?: string;
  icon?: React.ComponentProps<typeof Lucide>["icon"];
  variant?: "default" | "danger";
  onClick: () => void;
}

interface ActionModalProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  actions: ActionItem[];
  width?: string;
}

const ActionModal: React.FC<ActionModalProps> = ({
  isOpen,
  title,
  onClose,
  actions,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <Dialog.Panel className="mt-40 p-6">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClose();
          }}
          className="absolute top-0 right-0 mt-3 mr-3"
        >
          <Lucide icon="X" className="w-6 h-6 text-slate-400" />
        </a>

        <h3 className="text-lg font-semibold mb-4">{title}</h3>

        <div className="space-y-2">
          {actions.map((action, index) => {
            const isDanger = action.variant === "danger";

            return (
              <button
                key={index}
                onClick={action.onClick}
                className={`w-full py-3 px-4 text-left rounded-lg flex items-center gap-3 transition-colors
                  ${isDanger
                    ? "hover:bg-red-50 text-red-600"
                    : "hover:bg-slate-100 text-slate-800"
                  }`}
              >
                {action.icon && (
                  <Lucide
                    icon={action.icon}
                    className={`w-5 h-5 ${isDanger ? "text-red-600" : "text-slate-600"}`}
                  />
                )}

                <div>
                  <div className="font-medium">{action.label}</div>
                  {action.description && (
                    <div
                      className={`text-xs ${
                        isDanger ? "text-red-400" : "text-slate-500"
                      }`}
                    >
                      {action.description}
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>

        <button
          onClick={onClose}
          className="w-full mt-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
        >
          Cancel
        </button>
      </Dialog.Panel>
    </Dialog>
  );
};

export default ActionModal;
